import CheckmateSelect from '../shared/CheckmateSelect';
import { IMultiSelectOption } from '../../interfaces/ILookup';
import { Modal } from 'react-bootstrap';
import React from 'react';

interface IWatchListModalProps {
    availableUsers: IMultiSelectOption[];
    defaultSelectedUsers: IMultiSelectOption[];
    onClose: () => void;
    onSubmit: (watchUsers: IMultiSelectOption[]) => void;
    open?: boolean;
    readonly?: boolean;
}

export function WatchListModal(props: IWatchListModalProps) {
    if (!props.open) return null;

    const [originalSelectedUsers] = React.useState<IMultiSelectOption[]>(
        props.defaultSelectedUsers
    );
    const [selectedUsers, setSelectedUsers] = React.useState<IMultiSelectOption[]>(
        props.defaultSelectedUsers
    );

    const handleSubmitClick = () => {
        props.onSubmit(selectedUsers);
    };

    const handleCancelClick = () => {
        setSelectedUsers(originalSelectedUsers);
        props.onClose();
    };

    return (
        <Modal centered show={props.open} backdrop>
            <Modal.Header>
                <Modal.Title>Watch List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <CheckmateSelect
                        isDisabled={props.readonly}
                        isMulti={true}
                        onChange={setSelectedUsers}
                        options={props.availableUsers.sort((a, b) => (a.label < b.label ? -1 : 1))}
                        placeholder="Select Watch Users"
                        value={selectedUsers.sort((a, b) => (a.label < b.label ? -1 : 1))}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-black" onClick={handleSubmitClick}>
                    OK
                </button>
                <button className="btn btn-default" onClick={handleCancelClick}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}
